// extracted by mini-css-extract-plugin
module.exports = {"options":"W2lq5","label":"_1xcO5","labelText":"Dhmbc","checkbox":"_3GkNn"};